var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user-group_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.03 29.91"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".user-group_svg__cls-1{stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "user-group_svg__cls-1",
    d: "M5.47 17.08H3.23c-1.66 0-3.23-.8-3.23-2.65 0-1.35-.05-5.89 2.07-5.89.35 0 2.09 1.42 4.34 1.42.76 0 1.51-.13 2.22-.38a7.486 7.486 0 001.27 5.37c-1.71.04-3.33.82-4.42 2.13M6.41 8.54c-2.36 0-4.27-1.91-4.27-4.27A4.26 4.26 0 016.4 0c2.36 0 4.27 1.91 4.27 4.27 0 2.36-1.91 4.27-4.27 4.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "user-group_svg__cls-1",
    d: "M23.3 29.89H8.72c-2.25.2-4.24-1.46-4.44-3.71-.02-.2-.02-.41 0-.62 0-3.77.88-9.56 5.77-9.56.57 0 2.64 2.32 5.97 2.32S21.42 16 21.99 16c4.89 0 5.77 5.79 5.77 9.56.14 2.26-1.58 4.2-3.84 4.33-.21.01-.41 0-.62 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "user-group_svg__cls-1",
    d: "M16.01 17.08a6.41 6.41 0 116.41-6.41c0 3.54-2.87 6.4-6.41 6.41M25.62 8.54c-2.36 0-4.27-1.91-4.27-4.27 0-2.36 1.91-4.27 4.27-4.27 2.36 0 4.27 1.91 4.27 4.27 0 2.36-1.91 4.27-4.27 4.27M28.79 17.08h-2.24a5.919 5.919 0 00-4.42-2.14 7.561 7.561 0 001.35-4.27c0-.37-.03-.74-.08-1.1.71.25 1.46.38 2.22.38 2.25 0 3.99-1.42 4.34-1.42 2.12 0 2.07 4.54 2.07 5.89 0 1.85-1.57 2.65-3.24 2.65"
  })));
}

export default __webpack_public_path__ + "efe9fa4042456a249438889b1af26981.svg";
export { SvgUserGroup as ReactComponent };